// src/services/FeedbackService.ts

import { BaseService } from "@services/BaseService";

interface FeedbackPayload {
  feedback: string;
  feedback_type: string;
  report_id?: string;
  chat_session_id?: string;
}

class ChatService extends BaseService {
  submitFeedback(data: FeedbackPayload, type: "chat" | "report") {
    return this.post(`/projects/feedback?type=${type}`, { data });
  }
}

export const chatService = new ChatService();
